// ナビゲーションバーで指定されているページ

// 貸出
export const LendCacheName = 'lend'

// 返却
export const ReturnCacheName = 'return'

// 資料の管理
export const BibliographiesCacheName = 'bibliographies'

// 利用者
export const UserCacheName = 'user'

// レファレンス
export const ReferenceCacheName = 'reference'

// トップページメニュー

// 資料の管理：簡易発注
export const SimpleOrderingCacheName = 'simpleOrdering'

// デフォルトページのインクルードで使用する配列
export const DefaultIncludeCacheArray = [
  LendCacheName,
  ReturnCacheName,
  BibliographiesCacheName,
  UserCacheName,
  ReferenceCacheName,
  SimpleOrderingCacheName
]
